
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.352 2.952c.078-.522.437-1.077.948-1.077.517 0 .937.42.937.938h1.875A2.816 2.816 0 0013.3 0c-1.577 0-2.603 1.345-2.803 2.675L9.895 6.75H7.019v1.875h2.598L7.78 21.05l-.006.044c-.05.498-.44 1.031-.942 1.031a.939.939 0 01-.937-.938H4.019A2.816 2.816 0 006.83 24c1.578 0 2.661-1.366 2.805-2.695l1.877-12.68h2.818V6.75H11.79l.562-3.798zM19.981 11.625H17.73l-1.218 1.832-.813-1.832h-2.05l1.632 3.683-2.6 3.91h2.251l1.25-1.878.833 1.879h2.05l-1.653-3.73 2.57-3.864z"}})])
          )
        }
      }
    